// extracted by css-extract-rspack-plugin
export default {"RequestNonprofitWrapper":"RequestNonprofitPrompt_RequestNonprofitWrapper__MHQJ+","RequestNonprofitWrapperStart":"RequestNonprofitPrompt_RequestNonprofitWrapperStart__LA3Am"};